<template>
  <div id="funcionario-desempenho">
    <my-tour v-if="itens.length > 0" :steps="steps" name="steps-desempenho"></my-tour>
    <section id="content">
      <!--start container-->
      <div class="container">
        <TituloPagina titulo="Situação atual dos usuários"/>
        <div class="row">
          <div class="col s12" :class="classe">
            <div class="card-panel">
              <div class="row">
                <div class="col s12 m12 l12">
                  <div style="100%">
                    <div
                      class="pb-1"
                      style="display: flex;justify-content: flex-end;align-items: center;"
                    >
                      <div class="pl-2" id="export-file">
                        <button class="btn waves-effect waves-light right btn-default" @click="downloadXLS">
                          <i class="material-icons left">file_download</i>
                          Exportar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tbl-header">
                <table class="bordered striped">
                  <thead class="pushpin">
                    <tr class="pushpin">
                      <th id="colNome">Nome</th>
                      <th id="colEtapa1" class="center hide-on-med-and-down">Leads indicados</th>
                      <th id="colEtapa2" class="center hide-on-med-and-down">Contato telefônico</th>
                      <th id="colEtapa3" class="center hide-on-med-and-down">Visita</th>
                      <th id="colEtapa4" class="center hide-on-med-and-down">Em negociação</th>
                      <th id="colEtapa5" class="center hide-on-med-and-down">Efetivado</th>
                      <th id="colEtapa6" class="center hide-on-med-and-down">Não efetivado</th>
                      <th id="colEtapa7" class="center">Total de Leads</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="tbl-content">
                <table class="bordered striped">
                  <tbody>
                    <tr v-for="item in paginationConfig.itens">
                      <td>{{ item.nome }}</td>
                      <td class="center hide-on-med-and-down">{{ item.distribuicaoLeads }}</td>
                      <td class="center hide-on-med-and-down">{{ item.contatoTelefonico }}</td>
                      <td class="center hide-on-med-and-down">{{ item.visita }}</td>
                      <td class="center hide-on-med-and-down">{{ item.emNegociacao }}</td>
                      <td class="center hide-on-med-and-down">{{ item.efetivado }}</td>
                      <td class="center hide-on-med-and-down">{{ item.naoEfetivado }}</td>
                      <td class="center">
                        {{
                        (item.distribuicaoLeads +
                        item.contatoTelefonico +
                        item.visita +
                        item.emNegociacao +
                        item.efetivado +
                        item.naoEfetivado)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <Pagination
                v-if="itens.length > 0"
                :perPage="paginationConfig.perPage"
                :qty="paginationConfig.qty"
                :setCurrent="setCurrent"
                :current="paginationConfig.current"
              />
            </div>
          </div>

          <!-- INICO FILTRO -->
          <card
            title="Filtros"
            v-if="showFiltro"
            :showActions="showCardActionsFilter"
            @clearFilter="clearFilter"
          >
            <template slot="content">
              <div class="row" id="filter2">
                <div class="Search">
                  <div class="col s12">
                    <span class="Search__title grey-text">Por Usuário:</span>
                  </div>
                  <div class="chip mt-3" v-for="func in getFuncionarioData">
                    {{func.pessoa_nome}}
                    <i
                      class="close material-icons"
                      @click="removeFilterFuncionario(func.id)"
                    >close</i>
                  </div>
                  <div class="Search input-field col s12 input-search">
                    <i class="material-icons">person_outline</i>
                    <input type="text" v-model="filtro.funcionario" class="autocomplete">
                    <i
                      @click="clearFieldFuncionario()"
                      class="material-icons md-18 grey-text clear"
                    >clear</i>
                    <label for="nome"></label>
                  </div>
                </div>
              </div>

              <ul class="collection">
                <li
                  class="collection-item pl-0 pr-0"
                  style="display: flex;justify-content: space-between;"
                  v-for="func in funcionariosFiltered"
                >
                  <span
                    class="title"
                    style="text-transform: capitalize; font-size: .9rem"
                  >{{ func.pessoa_nome.toLowerCase() }}</span>
                  <div class="secondary-content">
                    <input
                      type="checkbox"
                      v-model="checkFuncionarios"
                      :value="func.id"
                      :id="'func'+func.id"
                    >
                    <label :for="'func'+func.id"></label>
                  </div>
                </li>
              </ul>
            </template>
          </card>
          <!-- FIM FILTRO -->
        </div>
      </div>
      <!--end container-->
    </section>
  </div>
</template>
<style>
table {
  width: 100%;
  table-layout: fixed;
}
.tbl-header {
  background-color: rgba(255, 255, 255, 0.3);
}
.tbl-content {
  max-height: 100vh;
  overflow-x: auto;
  margin-top: 0px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
<script>
import { get } from "@/helpers/api";
import TituloPagina from "@/components/common/TituloPagina";

import Pagination from "@/components/common/Pagination/Pagination";
import ListHelper from "@/helpers/list";
import MyTour from "@/components/common/MyTour.vue";
import Auth from "@/store/auth";
import {
  DONO,
  GERENTE,
  CORRETOR,
  ESPECIALISTA,
  LIDER,
  MASTER,
  PARCEIRO
} from "@/constants/funcionarioCargo.js";
import TourHelper from "@/helpers/tour";
import Card from "@/components/common/Card/Card";
import { isMultiEmpresa } from "@/environment";

export default {
  components: {
    TituloPagina,
    Pagination,
    MyTour,
    Card
  },
  data: () => ({
    paginationConfig: {
      perPage: 20,
      qty: 1,
      current: 1,
      itens: []
    },
    showFiltro: true,
    classe: "m10 l10",
    gridData: [],
    checkFuncionarios: [],
    funcionariosFiltered: [],
    showCardActionsFilter: true,
    funcionarios: [],
    filtro: {
      funcionario: []
    },
    itens: [],
    steps: [
      {
        parent: "#colNome",
        target: "#colNome",
        content: "Aqui estão os funcionários",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa1",
        target: "#colEtapa1",
        content:
          "Quantidades de Leads que ainda não tiveram nenhum contato ou visita de cada funcionário!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa2",
        target: "#colEtapa2",
        content:
          "Quantidades de Leads que já recebeu alguma ligação ou tentativa de contato!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa3",
        target: "#colEtapa3",
        content: "Quantidades de Leads que já foi visitado!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa4",
        target: "#colEtapa4",
        content: "Quantidades de Leads que estão em processo de negociação!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa5",
        target: "#colEtapa5",
        content: "Quantidades de Leads efetivados!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa6",
        target: "#colEtapa6",
        content: "Quantidades de Leads negativados!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false
        }
      },
      {
        parent: "#colEtapa7",
        target: "#colEtapa7",
        content: "Total de Leads cada funcionário que está cadastrado!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "left",
          menu: false
        }
      },
      {
        parent: "#export-file",
        target: "#export-file",
        content:
          "Clicando aqui é possivel exportar a listagem completa do relatório!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "left",
          menu: false
        }
      },

      {
        parent: "#left-sidebar-nav",
        target: "#produtos",
        content:
          "Para ver os produtos cadastrados ou adicionar novos, basta no menu clicar em <b>Produtos</b>!",
        params: {
          cargos: [DONO, PARCEIRO, CORRETOR, ESPECIALISTA, LIDER],
          placement: "left",
          menu: true,
          route: "/produtos",
          subMenu: false
        }
      },
      {
        parent: "#left-sidebar-nav",
        target: "#ajuda",
        content:
          "Caso queira rever este tutorial, você pode clicar clicar em <b>Ajuda</b>, lá terá um botão para reiniciar o tour e a descrição dos itens que são abordados nele! Até breve!",
        params: {
          cargos: [GERENTE, ESPECIALISTA],
          placement: "left",
          menu: true,
          route: "/",
          subMenu: false
        }
      },
      {
        parent: "",
        target: "",
        content: "",
        params: {
          cargos: [DONO, PARCEIRO, CORRETOR, ESPECIALISTA, LIDER],
          placement: "left",
          menu: false
          // route: '/gerenciamento-leads'
        }
      }
    ]
  }),
  computed: {
    getFuncionarioData() {
      if (!this.checkFuncionarios.length) {
        return [];
      }
      return this.funcionarios.filter(func =>
        this.checkFuncionarios.some(checkFunc => checkFunc == func.id)
      );
    }
  },
  created() {
    // verifica se pode acessar componente
    if (
      Auth.getCargoUsuario() !== MASTER &&
      [DONO, GERENTE, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1
    ) {
      this.$router.push("/sempermissao");
    }
    if (isMultiEmpresa) {
      this.showFiltro = false;
      this.classe = "m12 l12";
    }
    this.steps = TourHelper.createSteps(this.steps);
    let self = this;
    get("funcionario/lista-desempenhos").then(function(response) {
      self.itens = response.data.result.data;
      self.paginationConfig.qty = self.itens.length;
      self.paginationConfig.itens = ListHelper.getInterval(
        self.itens,
        self.paginationConfig.current,
        self.paginationConfig.perPage
      );

      self.itens.forEach((obj, key) => {
        /// montando dados de filtro
        self.funcionarios[key] = {
          pessoa_nome: obj.nome,
          id: key
        };
      });
    });
  },
  watch: {
    gridData() {
      this.paginationConfig.qty = this.gridData.length;
      this.paginationConfig.current = 1;
      this.paginationConfig.itens = ListHelper.getInterval(
        this.gridData,
        1,
        this.paginationConfig.perPage
      );
    },
    "paginationConfig.current"() {
      this.paginationConfig.itens = ListHelper.getInterval(
        this.itens,
        this.paginationConfig.current,
        this.paginationConfig.perPage
      );
    },
    "filtro.funcionario"() {
      this.funcionariosFiltered = [];
      const func = this.filtro.funcionario;
      if (func) {
        this.funcionariosFiltered = this.funcionarios.filter(resp => {
          return resp.pessoa_nome.toLowerCase().includes(func.toLowerCase());
        });
      }
    },
    checkFuncionarios() {
      this.filtrar();
    }
  },
  methods: {
    clearFilter(e) {
      this.checkFuncionarios = [];
      this.funcionariosFiltered = [];
      this.filtro.funcionario = "";
    },
    clearFieldFuncionario() {
      this.filtro.funcionario = "";
      this.funcionariosFiltered = [];
    },
    removeFilterFuncionario(id) {
      this.checkFuncionarios = this.checkFuncionarios.filter(
        check => check != id
      );
    },
    setCurrent(current) {
      this.paginationConfig.current = current;
    },
    filtrar() {
      this.gridData = [];
      this.itens.forEach((obj, key) => {
        let incluiFuncionario = true;

        if (this.checkFuncionarios.length !== 0) {
          incluiFuncionario = this.checkFuncionarios.includes(key);
        }

        if (incluiFuncionario) {
          this.gridData.push(obj);
        }
      });
    },

    downloadXLS(args) {
      let self = this;
      let data, filename, link;
      let csv = this.convertArrayOfObjectsToCSV({
        data: self.itens
      });
      if (csv == null) return;

      filename = args.filename || "export.xls";

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);

      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    convertArrayOfObjectsToCSV(args) {
      let result, ctr, keys, columnDelimiter, lineDelimiter, data;

      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }

      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";

      keys = Object.keys(data[0]);

      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        });
        result += lineDelimiter;
      });

      return result;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/usuarios/Desempenho.vue